document.addEventListener('DOMContentLoaded', function () {
  if (document.location.href.indexOf('/collections/all?sort_by=best-selling') > -1) {
    document.location.href = '/collections/all';
  }
}, false);

if (window.matchMedia('(max-width: 768px)').matches) {
  window.onscroll = function () {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var scrollToTop = document.getElementById('scrollToTop');

    if (scrollToTop) {
      scrollToTop.style.display = scrollTop > 1200 ? 'block' : 'none';
    }
  };
}

(function () {
  var loaderIcon = '<svg class="lucide lucide-loader-circle" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function setupLoadingButton(element) {
    var content;
    var loader;

    if (!element) {
      return;
    }

    element.classList.add('loading-button');

    content = element.querySelector('.loading-button__content');
    loader = element.querySelector('.loading-button__loader');

    if (element.hasAttribute('data-loading-button-ready') && content && loader) {
      return;
    }

    if (!content) {
      content = document.createElement('span');
      content.className = 'loading-button__content';

      while (element.firstChild) {
        content.appendChild(element.firstChild);
      }

      element.appendChild(content);
    }

    if (!loader) {
      loader = document.createElement('span');
      loader.className = 'loading-button__loader';
      loader.setAttribute('aria-hidden', 'true');
      loader.innerHTML = loaderIcon;
      element.appendChild(loader);
    }

    element.setAttribute('data-loading-button-ready', 'true');
  }

  function setLoading(element, loading) {
    if (!element) {
      return;
    }

    setupLoadingButton(element);

    element.classList.toggle('is-loading', loading);

    if (loading) {
      element.setAttribute('aria-disabled', 'true');
      return;
    }

    element.removeAttribute('aria-disabled');
  }

  window.themeButtonLoading = {
    setup: setupLoadingButton,
    set: setLoading,
    start: function (element) {
      setLoading(element, true);
    },
    stop: function (element) {
      setLoading(element, false);
    }
  };

  document.addEventListener('click', function (event) {
    var button = closest(event.target, '[data-loading-button]');

    if (!button) {
      return;
    }

    if (button.classList.contains('is-loading')) {
      event.preventDefault();
      return;
    }

    setLoading(button, true);
  }, true);

  document.addEventListener('theme:loading:end', function () {
    document.querySelectorAll('[data-loading-button].is-loading').forEach(function (button) {
      setLoading(button, false);
    });
  });

  function setupAllLoadingButtons() {
    document.querySelectorAll('[data-loading-button]').forEach(setupLoadingButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAllLoadingButtons);
  } else {
    setupAllLoadingButtons();
  }
})();

(function () {
  var desktopHoverQuery = window.matchMedia('(hover: hover) and (min-width: 1000px)');
  var closeTimeout = null;

  function isDesktopHover() {
    return desktopHoverQuery.matches;
  }

  function closeDesktopNavigation(navBar) {
    if (!navBar || !isDesktopHover()) {
      return;
    }

    navBar.querySelectorAll('.is-dropdown-open').forEach(function (item) {
      item.classList.remove('is-dropdown-open');
    });

    navBar.querySelectorAll('.nav-dropdown--glued').forEach(function (menu) {
      menu.classList.remove('nav-dropdown--glued');
    });

    navBar.querySelectorAll('.nav-dropdown--inverse').forEach(function (menu) {
      menu.classList.remove('nav-dropdown--inverse');
    });

    navBar.querySelectorAll('[data-type="menuitem"][aria-haspopup][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });

    navBar.querySelectorAll('[data-type="menu"][aria-hidden="false"]').forEach(function (menu) {
      menu.setAttribute('aria-hidden', 'true');
      menu.style.maxWidth = '';
    });
  }

  function getNavigationItem(element) {
    if (!element || !element.closest) {
      return null;
    }

    return element.closest('.nav-dropdown__item, .nav-bar__item');
  }

  function hasOpenDropdown(item) {
    return item && (
      item.classList.contains('is-dropdown-open') ||
      item.querySelector('.is-dropdown-open, [data-type="menu"][aria-hidden="false"]')
    );
  }

  function closeDropdownItem(item) {
    if (!item) {
      return;
    }

    item.classList.remove('is-dropdown-open');

    item.querySelectorAll('.is-dropdown-open').forEach(function (openItem) {
      openItem.classList.remove('is-dropdown-open');
    });

    item.querySelectorAll('[data-type="menuitem"][aria-haspopup]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });

    item.querySelectorAll('[data-type="menu"][aria-hidden]').forEach(function (menu) {
      menu.setAttribute('aria-hidden', 'true');
      menu.classList.remove('nav-dropdown--glued');
      menu.classList.remove('nav-dropdown--inverse');
      menu.style.maxWidth = '';
    });
  }

  function refreshMenuState(menu) {
    if (!menu || menu.querySelector('.is-dropdown-open')) {
      return;
    }

    menu.classList.remove('nav-dropdown--glued');
    menu.classList.remove('nav-dropdown--inverse');
  }

  function closeSiblingDropdowns(currentItem) {
    var parentMenu = currentItem && currentItem.parentElement;

    if (!parentMenu || !parentMenu.closest('.nav-bar')) {
      return;
    }

    Array.prototype.forEach.call(parentMenu.children, function (sibling) {
      if (sibling !== currentItem && hasOpenDropdown(sibling)) {
        closeDropdownItem(sibling);
      }
    });

    refreshMenuState(parentMenu);
  }

  function scheduleClose(navBar) {
    clearTimeout(closeTimeout);

    closeTimeout = setTimeout(function () {
      closeDesktopNavigation(navBar);
    }, 120);
  }

  document.addEventListener('mouseleave', function (event) {
    var navBar = event.target && event.target.closest ? event.target.closest('.nav-bar') : null;

    if (!navBar) {
      return;
    }

    if (event.relatedTarget && navBar.contains(event.relatedTarget)) {
      return;
    }

    scheduleClose(navBar);
  }, true);

  function handleNavigationHover(event) {
    var navBar = event.target && event.target.closest ? event.target.closest('.nav-bar') : null;

    if (navBar) {
      clearTimeout(closeTimeout);

      if (isDesktopHover()) {
        var currentItem = getNavigationItem(event.target);

        if (currentItem) {
          closeSiblingDropdowns(currentItem);
        }
      }

      return;
    }

    document.querySelectorAll('.nav-bar').forEach(function (openNavBar) {
      if (openNavBar.querySelector('.is-dropdown-open')) {
        scheduleClose(openNavBar);
      }
    });
  }

  document.addEventListener('mouseover', handleNavigationHover, true);
  document.addEventListener('focusin', handleNavigationHover, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('.nav-bar').forEach(closeDesktopNavigation);
  });
})();

(function () {
  var lockCount = 0;
  var scrollY = 0;
  var previousBodyStyles = {};

  function storeBodyStyles() {
    previousBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflowY: document.body.style.overflowY
    };
  }

  function restoreBodyStyles() {
    document.body.style.position = previousBodyStyles.position || '';
    document.body.style.top = previousBodyStyles.top || '';
    document.body.style.left = previousBodyStyles.left || '';
    document.body.style.right = previousBodyStyles.right || '';
    document.body.style.width = previousBodyStyles.width || '';
    document.body.style.overflowY = previousBodyStyles.overflowY || '';
  }

  window.themeScrollLock = {
    lock: function () {
      lockCount += 1;

      if (lockCount > 1) {
        return;
      }

      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      storeBodyStyles();

      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflowY = 'scroll';
      document.body.classList.add('no-mobile-scroll');
    },
    unlock: function () {
      if (lockCount === 0) {
        return;
      }

      lockCount -= 1;

      if (lockCount > 0) {
        return;
      }

      document.body.classList.remove('no-mobile-scroll');
      restoreBodyStyles();
      window.scrollTo(0, scrollY);
      scrollY = 0;
    }
  };
})();

(function () {
  var ROOT_SELECTOR = '.product-list--scrollable:not(.product-list--stackable), .collection-list, .text-with-icons-section .text-with-icons';
  var CELL_SELECTOR = '.product-item, .collection-item, .collection-block-item, .block-list__item, .text-with-icons__item';
  var STYLE_ID = 'dm-native-slider-style';
  var instanceMap = new WeakMap();
  var mutationObserver = null;
  var initDebounce = null;
  var isRefreshingSliders = false;

  function isTextWithIconsRoot(root) {
    return !!(root && root.classList && root.classList.contains('text-with-icons') && root.closest('.text-with-icons-section'));
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }

  function isProductSliderRoot(root) {
    return !!(root && root.classList && root.classList.contains('product-list--scrollable'));
  }

  function isCollectionSliderRoot(root) {
    return !!(root && root.classList && root.classList.contains('collection-list'));
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.dm-native-slider-host { position: relative; }',
      '.dm-native-slider {',
      '  display: flex !important;',
      '  flex-wrap: nowrap !important;',
      '  overflow-x: auto !important;',
      '  overflow-y: hidden !important;',
      '  -ms-overflow-style: none;',
      '  scrollbar-width: none;',
      '  -webkit-overflow-scrolling: touch;',
      '  scroll-behavior: smooth;',
      '  scroll-snap-type: x mandatory;',
      '}',
      '.dm-native-slider > * {',
      '  flex: 0 0 auto;',
      '  scroll-snap-align: start;',
      '}',
      '.dm-native-slider > .product-item,',
      '.dm-native-slider > .collection-item,',
      '.dm-native-slider > .collection-block-item,',
      '.dm-native-slider > .block-list__item,',
      '.dm-native-slider > .text-with-icons__item {',
      '  position: relative !important;',
      '  left: auto !important;',
      '  top: auto !important;',
      '}',
      '.dm-native-slider::-webkit-scrollbar { display: none; width: 0; height: 0; }',
      '[data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item,',
      '[data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item,',
      '[data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item {',
      '  margin-right: 14px !important;',
      '}',
      '[data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item,',
      '[data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item,',
      '[data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item {',
      '  width: var(--dm-slider-item-width) !important;',
      '}',
      '[data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item:last-child,',
      '[data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item:last-child,',
      '[data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item:last-child {',
      '  margin-right: 0 !important;',
      '}',
      '[data-section-type="featured-collection"] .dm-native-grid.product-list--scrollable,',
      '[data-section-type="product-recommendations"] .dm-native-grid.product-list--scrollable,',
      '[data-section-type="recently-viewed-products"] .dm-native-grid.product-list--scrollable {',
      '  flex-wrap: wrap !important;',
      '  overflow: visible !important;',
      '  gap: 14px;',
      '}',
      '[data-section-type="featured-collection"] .dm-native-grid.product-list--scrollable > .product-item,',
      '[data-section-type="product-recommendations"] .dm-native-grid.product-list--scrollable > .product-item,',
      '[data-section-type="recently-viewed-products"] .dm-native-grid.product-list--scrollable > .product-item {',
      '  width: var(--dm-grid-item-width) !important;',
      '  margin-right: 0 !important;',
      '}',
      '[data-section-type="featured-collection"] .dm-native-grid-scroller,',
      '[data-section-type="product-recommendations"] .dm-native-grid-scroller,',
      '[data-section-type="recently-viewed-products"] .dm-native-grid-scroller {',
      '  overflow: visible !important;',
      '  white-space: normal !important;',
      '}',
      '.dm-native-slider-host .dm-native-slider-nav {',
      '  opacity: 0;',
      '  transform: translateY(-50%) scale(.95);',
      '  pointer-events: none;',
      '  transition: opacity .2s ease, transform .2s ease;',
      '}',
      '.dm-native-slider-host:hover .dm-native-slider-nav,',
      '.dm-native-slider-host:focus-within .dm-native-slider-nav {',
      '  opacity: 1;',
      '  transform: translateY(-50%) scale(1);',
      '  pointer-events: auto;',
      '}',
      '.dm-native-slider-nav {',
      '  position: absolute;',
      '  top: 50%;',
      '  width: 48px;',
      '  height: 48px;',
      '  border: var(--border-size-theme) solid var(--border-color);',
      '  border-radius: 999px;',
      '  background: #fff;',
      '  color: var(--heading-color);',
      '  display: inline-flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  z-index: 4;',
      '  cursor: pointer;',
      '}',
      '.dm-native-slider-nav[disabled] { display: none !important; }',
      '.dm-native-slider-nav--prev { left: -18px; }',
      '.dm-native-slider-nav--next { right: -18px; }',
      '.dm-native-slider-nav svg { width: 14px; height: 14px; stroke: currentColor; stroke-width: 2.4px; fill: none; }',
      '@media (max-width: 999px) {',
      '  .dm-native-slider-nav { display: none !important; }',
      '}',
      '@media (max-width: 640px) {',
      '  .dm-native-slider.product-list--scrollable,',
      '  .dm-native-slider.collection-list,',
      '  .text-with-icons-section .dm-native-slider.text-with-icons {',
      '    scroll-padding-left: var(--mobile-container-gutter);',
      '    scroll-padding-right: var(--mobile-container-gutter);',
      '  }',
      '  [data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item,',
      '  [data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item,',
      '  [data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item {',
      '    flex: 0 0 62% !important;',
      '    width: 62% !important;',
      '    min-width: 62% !important;',
      '    max-width: 62% !important;',
      '    box-sizing: border-box;',
      '  }',
      '  [data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper,',
      '  [data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper,',
      '  [data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper {',
      '    width: 100% !important;',
      '    min-width: 0;',
      '  }',
      '  [data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper .aspect-ratio,',
      '  [data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper .aspect-ratio,',
      '  [data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper .aspect-ratio {',
      '    width: 100% !important;',
      '    max-width: 100% !important;',
      '    padding-bottom: 100% !important;',
      '  }',
      '  [data-section-type="featured-collection"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper img,',
      '  [data-section-type="product-recommendations"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper img,',
      '  [data-section-type="recently-viewed-products"] .dm-native-slider.product-list--scrollable > .product-item .product-item__image-wrapper img {',
      '    width: 100% !important;',
      '    height: 100% !important;',
      '    object-fit: contain;',
      '  }',
      '  .dm-native-slider.collection-list > .collection-item {',
      '    margin: 0 14px 0 0 !important;',
      '  }',
      '  .dm-native-slider.collection-list > .collection-item:first-child {',
      '    margin-left: var(--mobile-container-gutter) !important;',
      '  }',
      '  .dm-native-slider.collection-list > .collection-item:last-child {',
      '    margin-right: var(--mobile-container-gutter) !important;',
      '  }',
      '  .text-with-icons-section .dm-native-slider.text-with-icons > .text-with-icons__item {',
      '    width: calc(100% - (var(--mobile-container-gutter) * 2)) !important;',
      '    margin: 0 14px 0 0 !important;',
      '  }',
      '  .text-with-icons-section .dm-native-slider.text-with-icons > .text-with-icons__item:first-child {',
      '    margin-left: var(--mobile-container-gutter) !important;',
      '  }',
      '  .text-with-icons-section .dm-native-slider.text-with-icons > .text-with-icons__item:last-child {',
      '    margin-right: var(--mobile-container-gutter) !important;',
      '  }',
      '}',
      '@media (min-width: 641px) and (max-width: 999px) {',
      '  .dm-native-slider.product-list--scrollable,',
      '  .text-with-icons-section .dm-native-slider.text-with-icons {',
      '    scroll-padding-left: var(--desktop-container-gutter);',
      '    scroll-padding-right: var(--desktop-container-gutter);',
      '  }',
      '  .text-with-icons-section .dm-native-slider.text-with-icons > .text-with-icons__item {',
      '    width: calc(50% - 22px) !important;',
      '    margin: 0 14px 0 0 !important;',
      '  }',
      '  .text-with-icons-section .dm-native-slider.text-with-icons > .text-with-icons__item:first-child {',
      '    margin-left: var(--desktop-container-gutter) !important;',
      '  }',
      '  .text-with-icons-section .dm-native-slider.text-with-icons > .text-with-icons__item:last-child {',
      '    margin-right: var(--desktop-container-gutter) !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function getCellElements(root) {
    var cells = [];
    for (var i = 0; i < root.children.length; i += 1) {
      var child = root.children[i];
      if (child && child.nodeType === 1 && child.matches(CELL_SELECTOR)) {
        cells.push(child);
      }
    }
    return cells;
  }

  function getOuterWidth(element) {
    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle(element);
    var marginLeft = parseFloat(styles.marginLeft) || 0;
    var marginRight = parseFloat(styles.marginRight) || 0;

    return rect.width + marginLeft + marginRight;
  }

  function getVisibleColumns(root, cells) {
    var rootWidth = root.getBoundingClientRect().width;

    if (rootWidth <= 0) {
      return 0;
    }

    for (var i = 0; i < cells.length; i += 1) {
      var cellWidth = getOuterWidth(cells[i]);

      if (cellWidth > 0) {
        return Math.max(Math.floor((rootWidth + 1) / cellWidth), 1);
      }
    }

    return 0;
  }

  function getConfiguredVisibleColumns(root) {
    var columns = parseInt(root.getAttribute('data-visible-columns'), 10);

    return columns > 0 ? columns : 0;
  }

  function getEffectiveVisibleColumns(root, cells) {
    return getConfiguredVisibleColumns(root) || getVisibleColumns(root, cells);
  }

  function isStaticProductGridRoot(root) {
    var section = root.closest('[data-section-type]');

    if (!section) {
      return false;
    }

    var sectionType = section.getAttribute('data-section-type');

    return isProductSliderRoot(root) && (
      sectionType === 'featured-collection' ||
      sectionType === 'product-recommendations' ||
      sectionType === 'recently-viewed-products'
    );
  }

  function getSectionType(root) {
    var section = root.closest('[data-section-type]');

    return section ? section.getAttribute('data-section-type') : '';
  }

  function applyFeaturedCollectionSliderSizing(root, visibleColumns) {
    var gap = 14;
    var totalGap = Math.max(visibleColumns - 1, 0) * gap;

    root.style.setProperty('--dm-slider-item-width', 'calc((100% - ' + totalGap + 'px) / ' + visibleColumns + ')');
  }

  function applyStaticProductGrid(root, visibleColumns) {
    if (!isStaticProductGridRoot(root) || visibleColumns <= 0) {
      return;
    }

    var gap = 14;
    var totalGap = Math.max(visibleColumns - 1, 0) * gap;

    root.classList.add('dm-native-grid');
    if (root.parentElement) {
      root.parentElement.classList.add('dm-native-grid-scroller');
    }
    root.style.setProperty('--dm-grid-item-width', 'calc((100% - ' + totalGap + 'px) / ' + visibleColumns + ')');
  }

  function shouldUseNativeSlider(root, cells, visibleColumns) {
    if (!isDesktopViewport()) {
      return true;
    }

    if (isTextWithIconsRoot(root)) {
      return false;
    }

    if (!isProductSliderRoot(root) && !isCollectionSliderRoot(root)) {
      return true;
    }

    if (cells.length <= 1) {
      return false;
    }

    if (typeof visibleColumns === 'undefined') {
      visibleColumns = getEffectiveVisibleColumns(root, cells);
    }

    if (visibleColumns === 0) {
      return true;
    }

    return cells.length > visibleColumns;
  }

  function cleanupLegacyWrappers(root) {
    // Unwrap direct Flickity viewport if it still exists in DOM
    for (var i = 0; i < root.children.length; i += 1) {
      var child = root.children[i];
      if (!child || child.nodeType !== 1 || !child.classList.contains('flickity-viewport')) {
        continue;
      }

      var slider = null;
      for (var j = 0; j < child.children.length; j += 1) {
        if (child.children[j].classList && child.children[j].classList.contains('flickity-slider')) {
          slider = child.children[j];
          break;
        }
      }

      if (slider) {
        while (slider.firstChild) {
          root.insertBefore(slider.firstChild, child);
        }
      } else {
        while (child.firstChild) {
          root.insertBefore(child.firstChild, child);
        }
      }

      child.remove();
      i -= 1;
    }

    var junkSelectors = [
      '.flickity-prev-next-button',
      '.flickity-page-dots'
    ];

    for (var k = 0; k < junkSelectors.length; k += 1) {
      var junk = root.querySelectorAll(junkSelectors[k]);
      for (var m = 0; m < junk.length; m += 1) {
        if (junk[m].parentNode === root) {
          junk[m].remove();
        }
      }
    }
  }

  function clearCellInlineStyles(root) {
    var cells = root.querySelectorAll(CELL_SELECTOR);

    for (var i = 0; i < cells.length; i += 1) {
      var cell = cells[i];
      cell.style.position = '';
      cell.style.left = '';
      cell.style.top = '';
      cell.style.transform = '';
      cell.style.height = '';
    }

    root.style.height = '';
  }

  function destroyFlickity(root) {
    if (!window.Flickity || typeof window.Flickity.data !== 'function') {
      return;
    }

    var instance = null;
    try {
      instance = window.Flickity.data(root);
    } catch (error) {
      instance = null;
    }

    if (!instance) {
      return;
    }

    try {
      instance.destroy();
    } catch (error2) {
      // no-op
    }
  }

  function makeButton(type) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dm-native-slider-nav dm-native-slider-nav--' + type;
    button.setAttribute('aria-label', type === 'prev' ? 'Anterior' : 'Próximo');
    button.innerHTML = type === 'prev'
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4 L7 12 L15 20"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4 L17 12 L9 20"></path></svg>';
    return button;
  }

  function updateNavState(root, prevButton, nextButton) {
    var maxScroll = Math.max(root.scrollWidth - root.clientWidth, 0);
    var left = Math.max(root.scrollLeft, 0);

    if (prevButton) {
      prevButton.disabled = left <= 4;
    }

    if (nextButton) {
      nextButton.disabled = left >= maxScroll - 4;
    }
  }

  function attachControls(root) {
    var host = root.parentElement;
    if (!host) {
      return;
    }

    host.classList.add('dm-native-slider-host');

    var state = instanceMap.get(root) || {};

    if (!state.prevButton || !state.nextButton) {
      state.prevButton = makeButton('prev');
      state.nextButton = makeButton('next');

      state.onPrev = function () {
        var step = Math.max(Math.round(root.clientWidth * 0.9), 220);
        root.scrollBy({ left: -step, behavior: 'smooth' });
      };

      state.onNext = function () {
        var step = Math.max(Math.round(root.clientWidth * 0.9), 220);
        root.scrollBy({ left: step, behavior: 'smooth' });
      };

      state.prevButton.addEventListener('click', state.onPrev);
      state.nextButton.addEventListener('click', state.onNext);

      host.appendChild(state.prevButton);
      host.appendChild(state.nextButton);
    }

    if (!state.onScroll) {
      state.onScroll = function () {
        updateNavState(root, state.prevButton, state.nextButton);
      };
      root.addEventListener('scroll', state.onScroll, { passive: true });
    }

    if (!state.onResize) {
      state.onResize = function () {
        updateNavState(root, state.prevButton, state.nextButton);
      };
      window.addEventListener('resize', state.onResize);
    }

    updateNavState(root, state.prevButton, state.nextButton);
    instanceMap.set(root, state);
  }

  function teardownRoot(root) {
    var state = instanceMap.get(root);
    var host = root.parentElement;

    if (state) {
      if (state.prevButton && state.onPrev) {
        state.prevButton.removeEventListener('click', state.onPrev);
      }

      if (state.nextButton && state.onNext) {
        state.nextButton.removeEventListener('click', state.onNext);
      }

      if (state.onScroll) {
        root.removeEventListener('scroll', state.onScroll);
      }

      if (state.onResize) {
        window.removeEventListener('resize', state.onResize);
      }

      if (state.prevButton && state.prevButton.parentNode) {
        state.prevButton.parentNode.removeChild(state.prevButton);
      }

      if (state.nextButton && state.nextButton.parentNode) {
        state.nextButton.parentNode.removeChild(state.nextButton);
      }

      instanceMap.delete(root);
    }

    root.classList.remove('dm-native-slider');
    root.classList.remove('dm-native-grid');
    root.style.removeProperty('--dm-slider-item-width');
    root.style.removeProperty('--dm-grid-item-width');

    if (host) {
      host.classList.remove('dm-native-slider-host');
      host.classList.remove('dm-native-grid-scroller');
    }
  }

  function initRoot(root) {
    if (!root || !root.matches(ROOT_SELECTOR)) {
      return;
    }

    if (isTextWithIconsRoot(root) && !isMobileViewport()) {
      teardownRoot(root);
      return;
    }

    ensureStyle();
    destroyFlickity(root);
    cleanupLegacyWrappers(root);
    teardownRoot(root);

    root.classList.remove('flickity-enabled', 'is-draggable', 'flickity-rtl');

    clearCellInlineStyles(root);

    var cells = getCellElements(root);

    if (cells.length === 0) {
      return;
    }

    var visibleColumns = getEffectiveVisibleColumns(root, cells);

    if (!shouldUseNativeSlider(root, cells, visibleColumns)) {
      applyStaticProductGrid(root, visibleColumns);
      return;
    }

    root.classList.add('dm-native-slider');

    if (isDesktopViewport() && isStaticProductGridRoot(root) && visibleColumns > 0) {
      applyFeaturedCollectionSliderSizing(root, visibleColumns);
    }

    attachControls(root);
  }

  function runInit() {
    isRefreshingSliders = true;

    try {
      var roots = document.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < roots.length; i += 1) {
        initRoot(roots[i]);
      }
    } finally {
      setTimeout(function () {
        isRefreshingSliders = false;
      }, 0);
    }
  }

  function scheduleInit() {
    if (initDebounce) {
      clearTimeout(initDebounce);
    }

    initDebounce = setTimeout(function () {
      requestAnimationFrame(runInit);
    }, 60);
  }

  function setupObserver() {
    if (mutationObserver || !window.MutationObserver || !document.body) {
      return;
    }

    mutationObserver = new MutationObserver(function (mutations) {
      if (isRefreshingSliders) {
        return;
      }

      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];

        if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
          scheduleInit();
          return;
        }

        if (mutation.type === 'attributes') {
          var target = mutation.target;
          if (target && target.closest && target.closest(ROOT_SELECTOR)) {
            scheduleInit();
            return;
          }
        }
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    runInit();
    setupObserver();
  });

  window.addEventListener('load', runInit);
  window.addEventListener('resize', scheduleInit);
  window.addEventListener('orientationchange', scheduleInit);

  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('shopify:section:unload', scheduleInit);
  document.addEventListener('shopify:section:select', scheduleInit);
  document.addEventListener('shopify:section:deselect', scheduleInit);
  document.addEventListener('shopify:section:reorder', scheduleInit);
  document.addEventListener('shopify:block:select', scheduleInit);
  document.addEventListener('shopify:block:deselect', scheduleInit);
  document.addEventListener('StartKernelLoading', scheduleInit);
  document.addEventListener('StartAsyncLoading', scheduleInit);
  document.addEventListener('StartShopifyLoading', scheduleInit);
  document.addEventListener('asyncLazyLoad', scheduleInit);
  document.addEventListener('lazyloaded', scheduleInit, true);

  runInit();
})();

(function () {
  var SLIDESHOW_SELECTOR = '[data-section-type="slideshow"] .slideshow.slideshow--preserve-ratio';
  var slideshowState = new WeakMap();

  function getState(slideshow) {
    var state = slideshowState.get(slideshow);
    if (!state) {
      state = {
        queued: false,
        retryCount: 0,
        resizeObserver: null,
        mutationObserver: null
      };
      slideshowState.set(slideshow, state);
    }
    return state;
  }

  function isVisibleElement(element) {
    if (!element || element.nodeType !== 1) {
      return false;
    }

    return window.getComputedStyle(element).display !== 'none';
  }

  function getSelectedSlide(slideshow) {
    return slideshow.querySelector('.slideshow__slide.is-selected') || slideshow.querySelector('.slideshow__slide');
  }

  function getActiveAspectRatioElement(slideshow) {
    var selectedSlide = getSelectedSlide(slideshow);
    if (!selectedSlide) {
      return null;
    }

    var aspectRatios = selectedSlide.querySelectorAll('.aspect-ratio');
    for (var i = 0; i < aspectRatios.length; i += 1) {
      if (isVisibleElement(aspectRatios[i])) {
        return aspectRatios[i];
      }
    }

    return aspectRatios[0] || null;
  }

  function parsePaddingBottomPercent(element) {
    if (!element) {
      return 0;
    }

    var styleValue = element.style ? element.style.paddingBottom : '';
    if (styleValue && styleValue.indexOf('%') > -1) {
      return parseFloat(styleValue) || 0;
    }

    var computedValue = window.getComputedStyle(element).paddingBottom || '';
    if (!computedValue) {
      return 0;
    }

    if (computedValue.indexOf('%') > -1) {
      return parseFloat(computedValue) || 0;
    }

    var elementWidth = element.clientWidth || element.getBoundingClientRect().width || 0;
    var pxValue = parseFloat(computedValue) || 0;
    if (elementWidth <= 0 || pxValue <= 0) {
      return 0;
    }

    return (pxValue / elementWidth) * 100;
  }

  function applyRatioFallbackHeight(slideshow) {
    var viewport = slideshow.querySelector('.flickity-viewport');
    if (!viewport) {
      return false;
    }

    var selectedSlide = getSelectedSlide(slideshow);
    var ratioElement = getActiveAspectRatioElement(slideshow);
    if (!ratioElement) {
      return false;
    }

    var ratioPercent = parsePaddingBottomPercent(ratioElement);
    var width = ratioElement.clientWidth || ratioElement.getBoundingClientRect().width || slideshow.clientWidth || slideshow.getBoundingClientRect().width || 0;
    if (ratioPercent <= 0 || width <= 0) {
      return false;
    }

    var expectedHeight = Math.round((width * ratioPercent) / 100);
    if (expectedHeight <= 0) {
      return false;
    }

    slideshow.style.minHeight = expectedHeight + 'px';
    viewport.style.minHeight = expectedHeight + 'px';

    if (selectedSlide) {
      selectedSlide.style.minHeight = expectedHeight + 'px';
    }

    var currentHeight = Math.round(viewport.getBoundingClientRect().height || 0);
    if (!currentHeight || currentHeight < Math.round(expectedHeight * 0.7)) {
      viewport.style.height = expectedHeight + 'px';

      var slider = viewport.querySelector('.flickity-slider');
      if (slider) {
        slider.style.height = expectedHeight + 'px';
      }
    }

    var slider = viewport.querySelector('.flickity-slider');
    if (slider) {
      slider.style.minHeight = expectedHeight + 'px';
    }

    return true;
  }

  function getFlickityInstance(slideshow) {
    if (!window.Flickity || typeof window.Flickity.data !== 'function') {
      return null;
    }

    try {
      return window.Flickity.data(slideshow);
    } catch (error) {
      return null;
    }
  }

  function refreshSlideshowHeight(slideshow) {
    var state = getState(slideshow);
    var flickity = getFlickityInstance(slideshow);
    var fallbackApplied = applyRatioFallbackHeight(slideshow);

    if (!flickity || !flickity.isActive) {
      if (state.retryCount < 8) {
        state.retryCount += 1;
        setTimeout(function () {
          queueRefresh(slideshow);
        }, 120);
      }
      return fallbackApplied;
    }

    if (slideshow.clientWidth <= 0) {
      return fallbackApplied;
    }

    state.retryCount = 0;

    flickity.resize();
    if (typeof flickity.reposition === 'function') {
      flickity.reposition();
    }

    if (typeof flickity.select === 'function') {
      flickity.select(flickity.selectedIndex || 0, false, true);
    } else if (typeof flickity.setGallerySize === 'function') {
      flickity.setGallerySize();
    }

    applyRatioFallbackHeight(slideshow);

    return true;
  }

  function queueRefresh(slideshow) {
    if (!slideshow || !slideshow.matches(SLIDESHOW_SELECTOR)) {
      return;
    }

    var state = getState(slideshow);
    if (state.queued) {
      return;
    }

    state.queued = true;
    requestAnimationFrame(function () {
      state.queued = false;
      refreshSlideshowHeight(slideshow);
    });
  }

  function scheduleBootRefreshes(slideshow) {
    var delays = [0, 120, 350, 800];
    for (var i = 0; i < delays.length; i += 1) {
      (function (delay) {
        setTimeout(function () {
          queueRefresh(slideshow);
        }, delay);
      })(delays[i]);
    }
  }

  function attachResizeObserver(slideshow) {
    var state = getState(slideshow);
    if (state.resizeObserver || !window.ResizeObserver) {
      return;
    }

    state.resizeObserver = new ResizeObserver(function () {
      queueRefresh(slideshow);
    });

    state.resizeObserver.observe(slideshow);

    var section = slideshow.closest('[data-section-id]');
    if (section) {
      state.resizeObserver.observe(section);
    }
  }

  function attachMutationObserver(slideshow) {
    var state = getState(slideshow);
    if (state.mutationObserver || !window.MutationObserver) {
      return;
    }

    state.mutationObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        var target = mutation.target;

        if (!target || target.nodeType !== 1) {
          continue;
        }

        if (
          target.classList.contains('flickity-viewport') ||
          target.classList.contains('flickity-slider') ||
          target.classList.contains('slideshow__slide') ||
          target.classList.contains('aspect-ratio')
        ) {
          queueRefresh(slideshow);
          return;
        }
      }
    });

    state.mutationObserver.observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  function initSlideshow(slideshow) {
    if (!slideshow || !slideshow.matches(SLIDESHOW_SELECTOR)) {
      return;
    }

    attachResizeObserver(slideshow);
    attachMutationObserver(slideshow);
    scheduleBootRefreshes(slideshow);
  }

  function initAllSlideshows(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var slideshows = scope.querySelectorAll(SLIDESHOW_SELECTOR);

    for (var i = 0; i < slideshows.length; i += 1) {
      initSlideshow(slideshows[i]);
    }
  }

  function getClosestSlideshow(target) {
    return target && target.closest ? target.closest(SLIDESHOW_SELECTOR) : null;
  }

  function refreshFromEventTarget(eventTarget) {
    if (!eventTarget || !eventTarget.closest) {
      initAllSlideshows(document);
      return;
    }

    var section = eventTarget.closest('[data-section-type="slideshow"]');
    if (section) {
      var slideshow = section.querySelector('.slideshow.slideshow--preserve-ratio');
      if (slideshow) {
        initSlideshow(slideshow);
        queueRefresh(slideshow);
        return;
      }
    }

    initAllSlideshows(document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllSlideshows(document);
  });

  window.addEventListener('load', function () {
    initAllSlideshows(document);
  });

  window.addEventListener('resize', function () {
    initAllSlideshows(document);
  });

  window.addEventListener('orientationchange', function () {
    initAllSlideshows(document);
  });

  document.addEventListener('lazyloaded', function (event) {
    var slideshow = getClosestSlideshow(event.target);
    if (slideshow) {
      queueRefresh(slideshow);
    }
  }, true);

  document.addEventListener('load', function (event) {
    if (!event.target || event.target.tagName !== 'IMG') {
      return;
    }

    var slideshow = getClosestSlideshow(event.target);
    if (slideshow) {
      queueRefresh(slideshow);
    }
  }, true);

  var sectionEvents = [
    'shopify:section:load',
    'shopify:section:select',
    'shopify:section:deselect',
    'shopify:section:reorder',
    'shopify:block:select',
    'shopify:block:deselect',
    'StartKernelLoading',
    'StartAsyncLoading',
    'StartShopifyLoading',
    'asyncLazyLoad'
  ];

  for (var i = 0; i < sectionEvents.length; i += 1) {
    document.addEventListener(sectionEvents[i], function (event) {
      refreshFromEventTarget(event.target);
    });
  }

initAllSlideshows(document);
})();

(function () {
  var drawer = null;
  var toggle = null;
  var isOpen = false;

  function isDrawerEnabled() {
    return window.theme && window.theme.cartType === 'drawer';
  }

  function findElements() {
    drawer = document.getElementById('cart-drawer');
    toggle = document.querySelector('[data-action="open-cart-drawer"][aria-controls="cart-drawer"]');
  }

  function setToggleState(expanded) {
    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function openDrawer(event) {
    if (!isDrawerEnabled() || !drawer) {
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (drawer.getAttribute('aria-hidden') === 'false') {
      return;
    }

    drawer.setAttribute('aria-hidden', 'false');
    window.themeScrollLock.lock();
    setToggleState(true);
    isOpen = true;

    var closeButton = drawer.querySelector('[data-action="close-cart-drawer"]');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeDrawer(event) {
    if (!drawer) {
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (drawer.getAttribute('aria-hidden') === 'true') {
      return;
    }

    drawer.setAttribute('aria-hidden', 'true');
    window.themeScrollLock.unlock();
    setToggleState(false);
    isOpen = false;
  }

  function updateCartCount(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;

    if (count === null) {
      return;
    }

    window.theme.cartCount = count;

    document.querySelectorAll('.header__cart-count').forEach(function (element) {
      element.textContent = count;
    });
  }

  function getHeaderSectionUrl() {
    var rootUrl = window.routes && window.routes.rootUrl ? window.routes.rootUrl : '/';
    var separator = rootUrl.indexOf('?') === -1 ? '?' : '&';

    return rootUrl + separator + 'section_id=header';
  }

  function replaceDrawerFromHtml(html) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    var freshDrawer = wrapper.querySelector('#cart-drawer');

    if (!freshDrawer || !drawer) {
      return;
    }

    var wasOpen = drawer.getAttribute('aria-hidden') === 'false';
    drawer.replaceWith(freshDrawer);
    drawer = freshDrawer;

    if (wasOpen) {
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  function rerenderDrawer() {
    if (!isDrawerEnabled()) {
      return Promise.resolve();
    }

    return fetch(getHeaderSectionUrl(), {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart_drawer_render_failed');
        }

        return response.text();
      })
      .then(replaceDrawerFromHtml)
      .catch(function () {});
  }

  function refreshCartCount() {
    if (!isDrawerEnabled()) {
      return Promise.resolve();
    }

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart_refresh_failed');
        }

        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart);
      })
      .catch(function () {});
  }

  function setCartLineLoading(lineElement, loading) {
    if (!lineElement) {
      return;
    }

    lineElement.classList.toggle('is-loading', loading);

    lineElement.querySelectorAll('button, input').forEach(function (element) {
      if (loading) {
        element.setAttribute('data-cart-drawer-was-disabled', element.disabled ? 'true' : 'false');
        element.disabled = true;
        return;
      }

      element.disabled = element.getAttribute('data-cart-drawer-was-disabled') === 'true';
      element.removeAttribute('data-cart-drawer-was-disabled');
    });
  }

  function changeCartLine(lineId, quantity, lineElement) {
    if (!lineId) {
      return Promise.resolve();
    }

    var parsedQuantity = Math.max(parseInt(quantity, 10) || 0, 0);
    if (lineElement) {
      setCartLineLoading(lineElement, true);
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    return fetch(window.routes.cartChangeUrl + '.js', {
      body: JSON.stringify({
        id: lineId,
        quantity: parsedQuantity
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart_change_failed');
        }

        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart);
        return rerenderDrawer();
      })
      .finally(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      })
      .catch(function () {
        if (lineElement) {
          setCartLineLoading(lineElement, false);
        }
      });
  }

  function handleProductAdded() {
    if (!isDrawerEnabled() || !drawer) {
      return;
    }

    Promise.all([refreshCartCount(), rerenderDrawer()]).finally(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      openDrawer();
    });
  }

  function handleCartRefresh() {
    if (!isDrawerEnabled() || !drawer) {
      return;
    }

    Promise.all([refreshCartCount(), rerenderDrawer()]);
  }

  document.addEventListener('DOMContentLoaded', function () {
    findElements();
  });

  document.addEventListener('click', function (event) {
    var openTrigger = closest(event.target, '[data-action="open-cart-drawer"]');

    if (openTrigger) {
      findElements();
      openDrawer(event);
      return;
    }

    if (closest(event.target, '[data-action="close-cart-drawer"]')) {
      closeDrawer(event);
      return;
    }

    var quantityButton = closest(event.target, '[data-cart-drawer-quantity]');

    if (quantityButton) {
      event.preventDefault();
      changeCartLine(quantityButton.getAttribute('data-line-id'), quantityButton.getAttribute('data-quantity'), closest(quantityButton, '.cart-drawer-line'));
      return;
    }

    var removeButton = closest(event.target, '[data-cart-drawer-remove]');

    if (removeButton) {
      event.preventDefault();
      changeCartLine(removeButton.getAttribute('data-line-id'), 0, closest(removeButton, '.cart-drawer-line'));
    }
  });

  document.addEventListener('change', function (event) {
    var input = closest(event.target, '[data-cart-drawer-input]');

    if (!input) {
      return;
    }

    changeCartLine(input.getAttribute('data-line-id'), input.value, closest(input, '.cart-drawer-line'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen) {
      closeDrawer(event);
    }
  });

  document.addEventListener('product:added', handleProductAdded);
  document.addEventListener('cart:refresh', handleCartRefresh);
})();
